import { render, staticRenderFns } from "./AplicacoesForm.vue?vue&type=template&id=20c5eab6&"
import script from "./AplicacoesForm.vue?vue&type=script&lang=js&"
export * from "./AplicacoesForm.vue?vue&type=script&lang=js&"
import style0 from "./AplicacoesForm.vue?vue&type=style&index=0&id=20c5eab6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports